import React, { useState, useEffect } from "react";
import { putChofer as modifChofer } from "../helpers/rutaChoferes";
import { Modal, Button } from "react-bootstrap";
import { getLocalidades } from "../helpers/rutaLocalidades";
import { getRutas } from "../helpers/rutaRutas";
import 'animate.css';

const ModalFormChofer= ({ chofer, handleClose, show }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formValues, setFormValues] = useState({
    codcho: "",
    razonsocial: "",
    domicilio: "",
    telefono: "",
    cuit: "",
    email: "",
    localidad: "",
  });

  useEffect(() => {
    if (chofer && chofer._id) {
      setFormValues({
        codcho: chofer.codcho || "",
        nombre: chofer.nombre || "",
        domicilio: chofer.domicilio || "",
        telefono: chofer.telefono || "",
        cuit: chofer.cuit || "",
        email: chofer.email || "",
        localidad: chofer.localidad?._id || "",
      });
    }
  }, [chofer]);

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const resp = await modifChofer(chofer._id, formValues);
      console.log("✅ Chofer actualizado:", resp);

      setShowSuccess(true); // Mostrar modal de éxito

      setTimeout(() => {
        setShowSuccess(false); // Ocultar mensaje
        handleClose();         // Cerrar modal principal
      }, 2000);
    } catch (error) {
      console.error("❌ Error al actualizar chofer:", error);
      // Podés agregar modal de error si querés
    }
  };


  const [localidades, setLocalidades] = useState({ data: {}, loading: true });
  const [rutas, setRutas] = useState({ data: {}, loading: true });

  useEffect(() => {
    getLocalidades().then((res) =>
      setLocalidades({ data: res, loading: false })
    );
    getRutas().then((res) => setRutas({ data: res, loading: false }));
  }, []);

  return (
    <>
    <Modal show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Modificar Chofer</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="form-group mt-2">
            <label>Nombre</label>
            <input
              type="text"
              className="form-control"
              name="nombre"
              required
              value={formValues.nombre}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Domicilio</label>
            <input
              type="text"
              className="form-control"
              name="domicilio"
              required
              value={formValues.domicilio}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Teléfono</label>
            <input
              type="text"
              className="form-control"
              name="telefono"
              required
              value={formValues.telefono}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>CUIT</label>
            <input
              type="text"
              className="form-control"
              name="cuit"
              required
              value={formValues.cuit}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              required
              value={formValues.email}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Localidad</label>
            <select
              className="form-control"
              name="localidad"
              value={formValues.localidad}
              onChange={handleChange}
              required
            >
              <option value="">Elija una opción</option>
              {localidades.data.localidades &&
                localidades.data.localidades.map((loc) => (
                  <option key={loc._id} value={loc._id}>
                    {loc.localidad}
                  </option>
                ))}
            </select>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button type="submit" variant="dark">
            Guardar
          </Button>
        </Modal.Footer>
      </form>
    </Modal>

    <Modal
      show={showSuccess}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="animate__animated animate__fadeInDown"
    >
      <Modal.Body className="text-center">
        <div style={{ fontSize: "3rem" }}>🖐</div>
        <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
      </Modal.Body>
    </Modal>
    </>
  );
};

export default ModalFormChofer;
